import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';

import { BaseSidebarComponent } from './core/layout/components/base-sidebar/base-sidebar.component';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { UserPermissionsService } from './core/auth/services/user-permissions.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, BaseSidebarComponent, SpinnerComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'bcr-tool';
  showLayout = true;

  readonly userPermissionsService = inject(UserPermissionsService);

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Hide layout for access-denied page
        this.showLayout = event.url !== '/access-denied';
      });
  }
}
